import * as React from "react";
import { Select } from "antd";
import { ZIdName, idNameFieldNames } from "src/types/ZIdName";
import { onError } from "src/common/onError";
import { ZUid } from "src/types/zUid";

interface PropsSelectObject {
  value?: ZUid;
  onChange?(newValue?: ZUid): void;
  disabled?: boolean;
  loadObjectOptions(): Promise<ZIdName[]>;
}

const filterOption = (input: string, option?: ZIdName) =>
  (option?.name ?? "").toLowerCase().includes(input.toLowerCase());

export const SelectObject: React.FC<PropsSelectObject> = (props) => {
  const { loadObjectOptions, value, onChange, disabled } = props;
  const onChangeObj = (v?: ZUid) => {
    onChange?.(v);
  };

  const [loading, setLoading] = React.useState(false);
  const [options, setOptions] = React.useState<ZIdName[]>([]);
  React.useEffect(() => {
    setLoading(true);
    loadObjectOptions()
      .then(setOptions)
      .finally(() => setLoading(false))
      .catch(onError);
  }, []);
  return (
    <Select<ZUid, ZIdName>
      allowClear
      showSearch
      placeholder="Выберите объект"
      filterOption={filterOption}
      fieldNames={idNameFieldNames}
      options={options}
      value={value}
      onChange={onChangeObj}
      placement="bottomLeft"
      disabled={disabled}
      loading={loading}
    />
  );
};
